<ckeditor
  [editor]="Editor"
  (change)="inputEvents($event)"
  (blur)="onTouched()"
  (ready)="setEditor($event)"
  [data]="value"
  [config]="editorConfig"
></ckeditor>
